class AddToCartForm extends HTMLElement {
    connectedCallback() {
        const form = this.querySelector('[js-add-to-cart-form]');
        this.addToCartbtn = this.querySelector("[js-add-to-cart-btn]");

        if (form) {
            form.addEventListener('submit', this.handleSubmit.bind(this));
        }
    }

    async handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(event.target);
        this.addToCartbtn.classList.add("is-loading");

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

          
           document.dispatchEvent(new CustomEvent("cart:refresh"));
            if (document.getElementById('Cart-Drawer')) {
              document.body.classList.add('open-cc');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          
          
            await response.json();
            this.addToCartbtn.classList.remove("is-loading");
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    }
}

customElements.define('add-to-cart-form', AddToCartForm);